declare global {
  interface Array<T> {
    toSorted: (compareFn?: (a: T, b: T) => number) => T[];
  }

  // eslint-disable-next-line no-var -- Necessário para declaração global
  var __DISCOVERY_POLYFILLS_LOADED__: boolean | undefined;
}

if (typeof globalThis.__DISCOVERY_POLYFILLS_LOADED__ === "undefined") {
  globalThis.__DISCOVERY_POLYFILLS_LOADED__ = true;

  if (typeof Array.prototype.toSorted !== "function") {
    // eslint-disable-next-line no-extend-native -- Necessário para adicionar polyfill no prototype
    Array.prototype.toSorted = function toSorted(
      this: unknown[],
      compareFn?: (a: unknown, b: unknown) => number,
    ) {
      return Array.from(this).sort(compareFn);
    };
  }
}

export {};
